import apiService from './api/api.service';

class MentorFeedbackService {
  async canSubmitFeedback(mentorId) {
    try {
      const response = await apiService.get(`/mentor-feedback/can-submit/${mentorId}`);
      return response;
    } catch (error) {
      console.error('Error checking feedback eligibility:', error);
      throw error;
    }
  }

  async submitFeedback(mentorId, rating, comment) {
    try {
      const response = await apiService.post('/mentor-feedback/submit', {
        mentorId,
        rating,
        comment
      });
      return response;
    } catch (error) {
      console.error('Error submitting feedback:', error);
      throw error;
    }
  }

  async getMentorFeedbacks(mentorId, limit = 10, offset = 0) {
    try {
      const response = await apiService.get(`/mentor-feedback/mentor/${mentorId}`, {
        params: { limit, offset }
      });
      return response;
    } catch (error) {
      console.error('Error fetching mentor feedbacks:', error);
      throw error;
    }
  }

  async getMyFeedbacks() {
    try {
      const response = await apiService.get('/mentor-feedback/my-feedbacks');
      return response;
    } catch (error) {
      console.error('Error fetching my feedbacks:', error);
      throw error;
    }
  }

  async updateFeedback(feedbackId, rating, comment) {
    try {
      const response = await apiService.put(`/mentor-feedback/${feedbackId}`, {
        rating,
        comment
      });
      return response;
    } catch (error) {
      console.error('Error updating feedback:', error);
      throw error;
    }
  }

  async deleteFeedback(feedbackId) {
    try {
      const response = await apiService.delete(`/mentor-feedback/${feedbackId}`);
      return response;
    } catch (error) {
      console.error('Error deleting feedback:', error);
      throw error;
    }
  }
}

export default new MentorFeedbackService();
